import React from 'react'
import logo from './logo.png'

const NavBar = () => {
    return (
        <nav className='text-light text-center'>
          <img src={logo} alt='logo' className='logo rounded-5 mt-3'></img>
              <h5 className='fw-bold px-3'>
                InvoiceMate
              </h5>
        </nav>
    );
};

export default NavBar